import Badge from './Badge';
import './badge.scss';

export default Badge;
